import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
    providedIn: 'root'
})
export class AtendimentoDBService extends DatabaseService {
    override classname: string = 'AtendimentoDBService';
    override table = 'atendimento';

    protected override migration: number = 1;

    override indices = [
        { name: 'by_id', field: 'id', unique: false, multiEntry: false },
        { name: 'by_tipo', field: 'tipo', unique: false, multiEntry: false },
        { name: 'by_categoria', field: 'categoria', unique: false, multiEntry: false },
        { name: 'by_ordem', field: 'ordem', unique: false, multiEntry: false }
    ];
}
